export function cqvRequestReachedGroup(request: {
  whatsAppSent?: boolean;
  telegramSent?: boolean;
}): boolean {
  return Boolean(request.whatsAppSent || request.telegramSent);
}
